const doc = [({"en":({"js":({"admin":({"roles":({"edit":({"the_role_was_saved":"The role was saved", "edit_role":"Edit role: %{role_name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;